import { toSecureCardNumberClipboardText } from './formatSecureCardNumber';
import { readSecureCardNumberText } from './readSecureCardNumberText';
export async function copySecureCardNumber(cardNumberElement) {
    const renderedText = readSecureCardNumberText(cardNumberElement);
    if (!renderedText || !navigator.clipboard?.writeText) {
        return false;
    }
    try {
        await navigator.clipboard.writeText(toSecureCardNumberClipboardText(renderedText));
        return true;
    }
    catch {
        return false;
    }
}
